<template>
  <section class="page--section">
    <div class="section__title">
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="18">
          <h2>{{ heading }}</h2>
        </el-col>
        <el-col :span="6" class="text-align-right">
          <router-link :to="{name:'TrainingVideos'}" class="section__title--link">
            <el-button type="text">{{ $t('trainingViewAllVideos') }}</el-button>
          </router-link>
        </el-col>
      </el-row>
    </div>

    <training-videos-listing
      layout
      :sm="8"
      :videos="videos">
    </training-videos-listing>
  </section>
</template>

<script>
  import TrainingVideosListing from '@/components/training/TrainingVideosListing.vue';

  export default {
    name  : 'TrainingOnDemand',
    props : {
      'heading': String,
      'videos' : {},
    },
    components : {
      TrainingVideosListing,
    },
  };
</script>

<style lang="scss" scoped>
</style>
